<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import {exists} from 'shared/utils/custom-utils';
    import {getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {UserRoles} from 'shared/services/current-auth.service';
    import KpGenericTopbar from 'shared/components/kp-generic-topbar/KpGenericTopbar.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import KpUserAvatar from 'shared/components/kp-user-avatar/KpUserAvatar.svelte';
    import SutorUserAccountSettingsPopover from './SutorUserAccountSettingsPopover.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();

    const user = pageContext.staticData.user;
    const readerRole = user.readerAccounts[0];
</script>

<KpGenericTopbar height="var(--sutor-topbar-height)">
    {#if exists(user.deletionEventId)}
        <KpChipTag chipStyle="danger-new" dataQa="reader-role-label-deleted">
            {localize(/* @kp-localization commons.Deleted */ 'commons.Deleted')}
        </KpChipTag>
    {/if}

    {#if readerRole?.blocked}
        <KpChipTag chipStyle="danger-new" dataQa="reader-role-label-blocked">
            {localize(/* @kp-localization ctenar.TransactionsBlocked */ 'ctenar.TransactionsBlocked')}
        </KpChipTag>
    {/if}

    {#if readerRole?.registrationExpired}
        <KpChipTag chipStyle="danger-new" dataQa="reader-role-label-registration-expired">
            {localize(/* @kp-localization ctenar.RegistrationExpired */ 'ctenar.RegistrationExpired')}
        </KpChipTag>
    {/if}

    {#if user.role.includes(UserRoles.ROLE_READER)}
        <KpChipTag chipStyle="accent-blue-new" dataQa="reader-role-label-reader">
            {localize(/* @kp-localization user.Reader */ 'user.Reader')}
        </KpChipTag>
    {/if}

    {#if user.role.includes(UserRoles.ROLE_LIBRARIAN)}
        <KpChipTag chipStyle="accent-blue-new" dataQa="reader-role-label-librarian">
            {localize(/* @kp-localization user.Librarian */ 'user.Librarian')}
        </KpChipTag>
    {/if}

    {#if user.role.includes(UserRoles.ROLE_LIBRARY)}
        <KpChipTag chipStyle="accent-blue-new" dataQa="reader-role-label-library">
            {localize(/* @kp-localization user.MvsLibrary */ 'user.MvsLibrary')}
        </KpChipTag>
    {/if}

    {#if user.role.includes(UserRoles.ROLE_SUPPLIER)}
        <KpChipTag chipStyle="accent-blue-new" dataQa="reader-role-label-supplier">
            {localize(/* @kp-localization user.Supplier */ 'user.Supplier')}
        </KpChipTag>
    {/if}

    <span class="user-name">{pipe(user, loc())}</span>

    <KpUserAvatar {user} sizePx="{24}"/>

    <div class="full-width-spacer"></div>

    <SutorUserAccountSettingsPopover/>
</KpGenericTopbar>